import { render, staticRenderFns } from "./TableReports.vue?vue&type=template&id=fc27ecf0"
import script from "./TableReports.vue?vue&type=script&lang=js"
export * from "./TableReports.vue?vue&type=script&lang=js"
import style0 from "./TableReports.vue?vue&type=style&index=0&id=fc27ecf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports